module.exports = __webpack_public_path__ + "static/img/au.00f851fc.svg";